import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
export function AddColorButton({ onClick }) {
    return (_jsx(Tooltip, Object.assign({ title: "Add color", arrow: true }, { children: _jsx(IconButton, Object.assign({ onClick: onClick, color: "primary", sx: {
                mb: "0.1rem",
            } }, { children: _jsx(AddCircleOutlineIcon, { sx: { fontSize: 20 } }) })) })));
}
